import { Spinner } from '@/components/ui/spinner';

export default function AppShellLoading() {
  return (
    <div className="bg-hzc_beige_200 min-h-[50vh] flex items-center justify-center">
      <Spinner className="text-hzc_purple_500" size={32} />
    </div>
  );
}
